'use client'

import { countryCode, flagImage } from '../../lib/countryFlag'

// Flag for a recognised country; nothing for "Austin, TX", "Remote", etc. The
// country name sits right beside it, so it is aria-hidden for screen readers
// but still carries alt text for crawlers. A client component only for the
// onError handler: the review cards around it render on the server.
export default function ReviewFlag({ location }) {
  const img = flagImage(countryCode(location))
  if (!img) return null
  return (
    <img
      className="rc-flag"
      src={img.src}
      srcSet={img.srcSet}
      alt={`${location} flag`}
      aria-hidden="true"
      width="20"
      height="15"
      loading="lazy"
      onError={(event) => event.currentTarget.remove()}
    />
  )
}
